/**
 * MCP read-only tool policy.
 *
 * Policy blocks any high-risk / mutation / real-execution intent and always
 * returns the same preview-only flag contract.
 */
import { MCP_READONLY_TOOL_IDS } from "./types.js";
export const MCP_READONLY_BLOCKED_ACTIONS = [
    // mutation / payment / messaging
    "save",
    "send",
    "send email",
    "send mail",
    "send whatsapp",
    "update",
    "package update",
    "delete",
    "remove",
    "drop",
    "insert",
    "payment",
    "pos",
    "invoice",
    "payroll",
    "salary",
    "disburse",
    "whatsapp",
    "email",
    "mail",
    "telegram",
    "sms",
    "slack message",
    // GitHub / deployment / external
    "github issue",
    "github action",
    "create issue",
    "shell",
    "npm install",
    "pip install",
    "external fetch",
    "fetch",
    "http request",
    "curl",
    "wget",
    // execution / provider-call intents (longer phrases before short substrings)
    "approved_execution",
    "approve execution",
    "approved execution",
    "real execution",
    "live execution",
    "provider call",
    "provider_call",
    "exec",
    "system",
    "command",
    "cmd",
    "bash",
    "powershell",
    "mutation",
    "mutate",
    // persistence / network / DB
    "db write",
    "persist",
    "store",
    "commit",
    "push",
    "deploy",
    "webhook",
    "write file",
    "file write",
    "database",
    "mongo",
    "supabase",
    "postgres",
];
export const MCP_READONLY_BLOCKED_KEYWORDS = new Set(MCP_READONLY_BLOCKED_ACTIONS);
export function isKnownMcpReadonlyToolId(toolId) {
    return MCP_READONLY_TOOL_IDS.includes(toolId);
}
export function evaluateMcpReadonlyToolPolicy(toolId, intent, userMessage) {
    if (!isKnownMcpReadonlyToolId(toolId)) {
        return { allowed: false, blockedReason: "unknown_tool_id", riskLevel: "unknown" };
    }
    const text = `${intent} ${userMessage}`.toLowerCase();
    for (const keyword of MCP_READONLY_BLOCKED_KEYWORDS) {
        if (text.includes(keyword.toLowerCase())) {
            return {
                allowed: false,
                blockedReason: `blocked_keyword_detected: ${keyword}`,
                riskLevel: "high",
            };
        }
    }
    return { allowed: true, riskLevel: "safe" };
}
export function getMcpReadonlyToolPolicyFlags() {
    return {
        previewOnly: true,
        readOnly: true,
        mutationExecuted: false,
        providerCallExecuted: false,
        realExecutionPerformed: false,
        externalNetworkEnabled: false,
        approvedExecutionEnabled: false,
        saveExecuted: false,
        sendExecuted: false,
        paymentExecuted: false,
        customerRecordUpdated: false,
    };
}
export function getMcpReadonlyToolRuntimeFlags() {
    return {
        previewOnly: false,
        readOnly: true,
        mutationExecuted: false,
        providerCallExecuted: false,
        // execution-site-id: mcp.readonly.runtime
        realExecutionPerformed: true,
        externalNetworkEnabled: false,
        approvedExecutionEnabled: false,
        saveExecuted: false,
        sendExecuted: false,
        paymentExecuted: false,
        customerRecordUpdated: false,
    };
}
//# sourceMappingURL=tool-policy.js.map